type BrowserLocation = Pick<Location, "hash" | "pathname" | "search">;
type BrowserHistory = Pick<History, "replaceState">;

export function normalizeLeadingSlashes(
  location: BrowserLocation = window.location,
  history: BrowserHistory = window.history
) {
  if (!location.pathname.startsWith("//")) {
    return false;
  }

  const pathname = `/${location.pathname.replace(/^\/+/, "")}`;
  history.replaceState(null, "", `${pathname}${location.search}${location.hash}`);

  return true;
}
